import { render, staticRenderFns } from "./SGPAlertaComponent.vue?vue&type=template&id=e3e0cce4"
import script from "./SGPAlertaComponent.vue?vue&type=script&lang=js"
export * from "./SGPAlertaComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPAlertaComponent.vue?vue&type=style&index=0&id=e3e0cce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports